
<template>
  <div class="card group-tabs">
    <div class="tabs-header">
      <div
        v-for="(g, index) in groups"
        :key="g.id"
        :class="['tab-item', index === activeIndex ? 'tab-item--active' : '']"
        @click="activeIndex = index"
      >
        <span class="tab-name">{{ g.deviceGroupName
 }}</span>
        <span class="tab-count">{{ g.devices ? g.devices.length : 0 }}</span>
      </div>
    </div>

    <div class="tabs-body">
      <div class="group-toolbar">
      
<!-- // @click="" -->
      <div>
      
           <button
          class="btn btn-primary"
         @click="goToTerminal(currentGroup)" >
          编组配置
        </button>

          <button
         
          class="btn btn-primary"
          :disabled="!selectedDorm"
          @click="importDorm"
        >
          导入选中宿舍到当前编组
        </button>
      </div>
        
        <span class="tip">
          可通过左右切换编组，双击宿舍进入终端详情。
        </span>
      </div>

      <div class="group-dorm-list">
        <div
          v-for="dorm in (currentGroup?.devices || [])"
          :key="dorm.deviceId"
          class="group-dorm-item"
          @dblclick="goToOperation(dorm)"
          
        >
          <div class="group-dorm-text"  :style="{ opacity: dorm.status !== 1 ? 0.4 : 1 }">
            <span class="group-dorm-name">{{ dorm.deviceName }}</span>
            <span class="group-dorm-meta">{{dorm.status == 1 ? '终端在线 · 已配置':'终端离线 · 已配置'}}</span>
          </div>
          <button class="btn btn-text" @click.stop="removeDorm(dorm)">
            移除
          </button>
        </div>
        <div
          v-if="currentGroup.devices.length === 0"
          class="group-dorm-item empty"
        >
          暂无宿舍，请在左侧选择后点击“导入”。
        </div>
      </div>

      <div class="hint">
        提示：通过编组功能，可以高效批量修改同组内终端的部分功能。点击“编组配置”进入配置页面，进行进一步操作。
      </div>
    </div>
  </div>
</template>


<script>
import { addDeviceToGroup,removeGroupDevice } from '@/api/api'
export default {
  name: 'GroupTabs',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    selectedDorm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    currentGroup() {
      return this.groups[this.activeIndex] || { devices: [] }
    }
  },
  
  methods: {

   triggerAlert() {
   
      this.$notify({
        title: '警告',
        message: '这是一个警告通知!',
        type: 'warning',
        duration: 0,
         offset: 45,
      });
    
    },

   async importDorm() {
      if (!this.selectedDorm) return
      const exists = this.currentGroup.devices.some(
        d => d.deviceId
 === this.selectedDorm.id
      )

      console.log(this.currentGroup.devices)
         console.log(this.selectedDorm)
      if (!exists) {
        const from = {}
        from.deviceId = this.selectedDorm.id
        from.deviceGroupId = this.currentGroup.deviceGroupId
        const res = await addDeviceToGroup(from)
        if(res.code == 0){
     
this.currentGroup.devices.push({ ...this.selectedDorm })

      }
      }
    },

   async removeDorm(dorm) {
      const from = {}
 
      from.deviceId = dorm.deviceId
      from.deviceGroupId = this.currentGroup.deviceGroupId
      const res = await removeGroupDevice(from)
      if(res.code == 0){
     
this.currentGroup.devices = this.currentGroup.devices.filter(
        d => d.deviceId !== dorm.deviceId
      )
      }
      
    },
    goToTerminal(dorm) {
      this.$router.push({ name: 'TerminalStatus', params: { group: dorm } })
    },

    goToOperation(dorm) {
      if(dorm.status === 1){
 this.$router.push({ name: 'TerminalOperation', params: { deviceId: dorm.deviceId } });
      }
    
}

  }
}
</script>

<style scoped>

/* 手机：搜索行竖排 */
@media (max-width: 600px) {
  .group-toolbar {
    flex-direction: column;
  }
  .group-toolbar .btn {
    width: 100%;
    margin-left:0px;
  }

   .group-toolbar div {
    width: 100%;
    display:flex;
    gap:10px;
    flex-wrap:wrap;
  }
}

.tabs-header {
  display: flex;
  border-bottom: 1px solid rgba(55, 65, 81, 0.85);
  margin-bottom: 12px;
  overflow-x: auto;
}

.tabs-header::-webkit-scrollbar {
  display: none;  /* 隐藏垂直和水平滚动条 */
}

.dorm-scroll::-webkit-scrollbar {
  display: none;  /* 隐藏垂直和水平滚动条 */
}

.tab-item {
  padding: 10px 18px;
  cursor: pointer;
  font-size: 14px;
  color: #9ca3af;
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-name {
  font-weight: 500;
}

.tab-count {
  min-width: 22px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(31, 41, 55, 0.9);
  font-size: 12px;
  text-align: center;
  color: #9ca3af;
}

.tab-item--active {
  color: #e5e7eb;
  font-weight: 600;
}

.tab-item--active .tab-count {
  background: rgba(37, 99, 235, 0.3);
  color: #bfdbfe;
}

.tab-item--active::after {
  content: '';
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: -2px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #60a5fa, #2563eb);
}

.tabs-body {
  margin-top: 8px;
}

.group-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 10px;
  flex-wrap: wrap;
}

.tip {
  font-size: 12px;
  color: #9ca3af;
}

.group-dorm-list {
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.95);
  box-shadow: inset 0 0 0 1px rgba(31, 41, 55, 1);
  max-height: 360px;
  overflow-y: scroll;
   /* 以下是隐藏滚动条的核心样式，兼容主流浏览器 */
  /* 1. Chrome、Safari、Edge 等webkit内核浏览器 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge 旧版 */
}

.group-dorm-list::-webkit-scrollbar {
  display: none; /* 直接隐藏滚动条 */
  width: 0; /* 备选方案：设置宽度为0 */
}

.group-dorm-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 14px;
  border-bottom: 1px solid rgba(31, 41, 55, 1);
  font-size: 14px;
  color: #e5e7eb;
}

.group-dorm-item:last-child {
  border-bottom: none;
}

.group-dorm-text {
  display: flex;
  flex-direction: column;
}

.group-dorm-name {
  font-weight: 500;
}

.group-dorm-meta {
  font-size: 12px;
  color: #9ca3af;
}

.group-dorm-item.empty {
  justify-content: center;
  color: #6b7280;
}

.hint {
  margin-top: 10px;
  font-size: 12px;
  color: #9ca3af;
}

@media (max-width: 600px) {
  .group-dorm-item {
    font-size: 13px;
  }
  .group-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
  .group-toolbar .btn {
    width: 100%;
  }
}
</style>
